module.exports = {
	"id": "dk-admin/createAcademy",
	"type": "object",
	"properties": {
		"name": {
			"type": "string",
			"minLength": 3,
			"maxLength": 50
		},
		"academyId": {
			"type": "string",
			"minLength": 3,
			"maxLength": 15
		},
		"location": {
			"type": "string",
			"minLength": 3,
			"maxLength": 15
		},
		"assessmentsPurchased": {
			"type": "integer",
			"minimum": 50,
			"maximum": 1000,
			"multipleOf": 50
		},
		"logins": {
			"type": "array",
			"maxItems": 1,
			"minItems": 1,
			"items": {
				"type": "object",
				"properties": {
					"name": {
						"type": "string",
						"minLength": 3
					},
					"email": {
						"type": "string",
						"format": "email",
						"maxLength": 255
					}
				}
			}
		}
	},
	"required": [
		"name",
		"academyId",
		"location",
		"assessmentsPurchased",
		"logins"
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/common/schema/createAcademy.json
// module id = 860
// module chunks = 0